import { Input } from 'reactstrap'

import { removeZeroWidthSpaces } from '../../../utils'

export const Component = Input

const HookComponent = (hoc) => {
  return function(props) {
    let WrappedInput = Input
    if (hoc && typeof hoc(Input) === 'function') {
      WrappedInput = hoc(Input)
    }
    const { setValue, dispatch, onChange = () => {}, value, validate } = props
    const _onChange = (e) => {
      setValue(removeZeroWidthSpaces(e.target.value))
      onChange({ dispatch, value: e.target.value })
    }
    const handleFocus = () => {
      if (validate) validate(false)
    }

    const handleBlur = () => {
      if (validate) validate(true)
    }
    return <WrappedInput {...props} value={value} onChange={_onChange} onFocus={handleFocus} onBlur={handleBlur} />
  }
}

export default HookComponent
